import { combineReducers } from "redux";
import form from "./Form/Form.reducer";
import modal from "./Modal/Modal.reducer";
import common from "./Common/Common.reducer";
import products from "./Products/Products.reducer";
import groupOrderDashboard from "./GroupOrder/GroupOrder.reducer";
import reportInformation from "./Report/Report.reducer";
export const rootReducer = combineReducers({
  common,
  form,
  modal,
  products,
  groupOrderDashboard,
  reportInformation,
});
